import React from 'react'
import { Avatar } from 'antd'
import { getNameSignature } from 'helper/utility'
import { leagueAttendanceStore } from 'state/league/leagueAttendance'

const LeagueParticipantAndDetails: React.FC = () => {
  const { selectedAttendee } = leagueAttendanceStore(store => ({
    selectedAttendee: store.selectedAttendee,
  }))

  if (!selectedAttendee) return null

  return (
    <div style={{ minWidth: '200px' }}>
      <div className="flex align-center gap-10px mb-20px">
        <Avatar size={40}>{getNameSignature(selectedAttendee.name)}</Avatar>
        <h3 className="text-14 w-600">{selectedAttendee.name}</h3>
      </div>

      {selectedAttendee.organization && (
        <div className="mb-10px">
          <p className="text-12">Organization</p>
          <p className="text-14 w-500">{selectedAttendee.organization}</p>
        </div>
      )}
      {selectedAttendee.team && (
        <div className="mb-10px">
          <p className="text-12">Team</p>
          <p className="text-14 w-500">{selectedAttendee.team}</p>
        </div>
      )}
      {selectedAttendee.division && (
        <div className="mb-10px">
          <p className="text-12">Division</p>
          <p className="text-14 w-500">{selectedAttendee.division}</p>
        </div>
      )}
      {selectedAttendee.checkInDate && (
        <div className="mb-10px">
          <p className="text-12">Check-in time</p>
          <p className="text-14 w-500">{selectedAttendee.checkInDate}</p>
        </div>
      )}
    </div>
  )
}

export default LeagueParticipantAndDetails
